<template>
  <div class="home-container">
    <div class="sub-title">
      <h2 ><a name="public"></a>公域获客</h2>
      <div class="sub-title-right">
        <ul>
          <li><a href="#public">公域获客</a></li>
          <li><a href="#private">私域拉新</a></li>
          <li><a href="#member">会员管理</a></li>
          <li v-if="buzzType !== 4"><a href="#league">Kids联盟</a></li>
        </ul>
        <div class="account-btn" @click="toAccount">我的账户</div>
      </div>
    </div>
    <div class="ad-item-wrapper">
      <div class="ad-item-content" style="padding-bottom: 0;">
        <div class="ad-item"  v-for="i in mediaPromotion" :key="i._id" 
        >
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true" @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"  class="demo-imgWrapper" >
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price-tip">刊例价：</span><span class="demo-price">{{i.price
                  }}</span>元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price-tip">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary"
            @click="gotoLink(i.link)"
             >{{ i.btn || '投放' }}</a-button>
          </a-popover>
         </div>
      </div> 
    </div>

    <h2 ><a name="private"></a>私域拉新</h2>
    <div class="ad-item-wrapper">
      <template>
        <a-tabs default-active-key="0" :animated="false">
         <a-tab-pane key="0" tab="线上广告" >
        <div class="each-content" v-if="marketing && marketing.length>0">
          <div class="ad-item-header"><h3>精准营销</h3></div>
          <div class="ad-item-content">
          <div class="ad-item"  v-for="i in marketing" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price-tip">刊例价：</span><span class="demo-price">{{i.price
                  }}</span>元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price-tip">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary" @click="jumpOutLink(i.link)"  >{{ i.btn || '投放' }}</a-button>
          </a-popover>
         </div>
          </div> 
        </div>
        <div class="each-content"  v-if="brand && brand.length>0">
          <div class="ad-item-header"><h3>品牌营销</h3></div>
          <div class="ad-item-content">
            <div class="ad-item"  v-for="i in brand" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ; border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc" v-if=" i.instruction ">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price-tip">刊例价：</span><span class="demo-price">{{i.price
                  }}</span>元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price-tip">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <!-- "  -->
            <a-button type="primary"  @click="gotoLink(i.link)">{{ i.btn || '投放' }}</a-button>
          </a-popover>
         </div>
          </div>
        </div>

        <div class="each-content"  v-if="community && community.length>0">
          <div class="ad-item-header"><h3>社群推广</h3></div>
          <div class="ad-item-content">
            <div class="ad-item"  v-for="i in community" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price-tip">刊例价：</span><span class="demo-price">{{i.price
                  }}</span>元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price-tip">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary" @click="gotoLink(i.link)">{{ i.btn || '投放' }}</a-button>
          </a-popover>
         </div>
          </div>
        </div>

         <div class="each-content"  v-if="activityApply && activityApply.length>0">
          <div class="ad-item-header"><h3>活动报名</h3></div>
          <div class="ad-item-content">
            <div class="ad-item"  v-for="i in activityApply" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price-tip">刊例价：</span><span class="demo-price">{{i.price
                  }}</span>元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price-tip">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary" @click="gotoLink(i.link)">{{ i.btn || '投放' }}</a-button>
          </a-popover>
         </div>
          </div>
        </div>


      </a-tab-pane>
      <a-tab-pane key="1" tab="线下点位">
        <div class="each-content">
          <div class="ad-item-header">
            <h3 style="margin-bottom: 0; padding-bottom: 0">门店点位</h3>
            <div class="account-btn-group">
              <div class="account-btn"  @click="gotoPlan">我的投放计划</div>
              <div class="account-btn"  @click="gotoMore"><i></i>去首页</div>
            </div>
          </div>
          <div class="ad-point-content" style="padding-top:16px">
            <div class="ad-item"  v-for="i in storePoint" :key="i._id">
              <img :src="i.icon" alt="">
              <div class="ad-name">
                {{ i.name }}
              </div>
              <div class="ad-desc">
               {{ i.subTitle }}
              </div>
              <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
                <template slot="content">
                  <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                    <div class="demo-title">投放示例</div>
                    <div class="demo-imgs">
                      <div class="arrow-left" @click="prev(i._id)">
                        <i class="arrow-left-icon"></i>
                      </div>
                      <div class="arrow-right" @click="next(i._id)">
                        <i class="arrow-right-icon"></i>
                      </div>
                      <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                      <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                        <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index" class="demo-imgWrapper" >
                        <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                        </div>
                      </Carousel>
                    </div>
                      <div class="demo-desc">{{ i.instruction }}</div>
                      <div  v-if="i.price"><span class="demo-price">刊例价：</span>{{i.price
                      }}元/档</div>
                      <div v-if="i.pricedesc"><span class="demo-price">价格说明：</span>{{ i.pricedesc }}</div>
                  </div>
                </template>
                <a-button type="primary"
                 @click="()=>jumpOutLink(i.link)"
                 >{{ i.btn || '投放' }}</a-button>
              </a-popover>
            </div>
            <div class="ad-item-more" @click="gotoMore">
              <img src="https://hzwimspic-1251601690.image.myqcloud.com/hzwimspic/1/ceee92d0-8b9e-11ef-a1a8-7170676c63df_size_237x419"/>
            </div>
          </div> 
        </div>
        <div class="each-content"  v-if="interactive && interactive.length>0">
          <div class="ad-item-header"><h3>互动冠名</h3></div>
          <div class="ad-item-wrapper">
            <div class="ad-item-content">
              <div class="ad-item"  v-for="i in interactive" :key="i._id">
                <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
                <img :src="i.icon" alt="" v-if="i.icon">
                <div class="ad-name">
                  {{ i.name }}
                </div>
                <div class="ad-desc">
                  {{ i.subTitle }}
                </div>
                <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
                  <template slot="content">
                    <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                      <div class="demo-title">投放示例</div>
                      <div class="demo-imgs">
                        <div class="arrow-left" @click="prev(i._id)">
                          <i class="arrow-left-icon"></i>
                        </div>
                        <div class="arrow-right" @click="next(i._id)">
                          <i class="arrow-right-icon"></i>
                        </div>
                        <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                        <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                          <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                          <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                          </div>
                        </Carousel>
                      </div>
                        <div class="demo-desc">{{ i.instruction }}</div>
                        <div  v-if="i.price"><span class="demo-price">刊例价：</span>{{i.price
                        }}元/档</div>
                        <div v-if="i.pricedesc"><span class="demo-price">价格说明：</span>{{ i.pricedesc }}</div>
                    </div>
                  </template>
                  <a-button type="primary" @click="()=>jumpOutLink(i.link)"  >{{ i.btn || '投放' }}</a-button>
                </a-popover>
              </div>
            </div>
          </div>
        </div>

      </a-tab-pane>
  
    </a-tabs>
      </template>
     
    </div>
    <h2  v-if="memberManager && memberManager.length>0"><a name="member"></a>会员管理</h2>
    <div class="ad-item-wrapper"  v-if="memberManager && memberManager.length>0">
      <div class="ad-item-content">
        <div class="ad-item"  v-for="i in memberManager" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index"   class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price">刊例价：</span>{{i.price
                  }}元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary" @click="()=>jumpOutLink(i.link)" >{{ i.btn || '投放' }}</a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <h2  v-if="kidsLeague && kidsLeague.length>0"><a name="league"></a>Kids联盟</h2>
    <div class="ad-item-wrapper" v-if="kidsLeague && kidsLeague.length>0">
      <div class="ad-item-content">
        <div class="ad-item"  v-for="i in kidsLeague" :key="i._id">
          <div class="ad-tag" v-if="i.sellpoint">{{ i.sellpoint }}</div>
          <img :src="i.icon" alt="" v-if="i.icon">
          <div class="ad-name">
            {{ i.name }}
          </div>
          <div class="ad-desc">
            {{ i.subTitle }}
          </div>
          <a-popover class="ad-btn" :destroyTooltipOnHide="true"  @mouseenter="resetCurrentIndex">
            <template slot="content">
              <div class="ad-demo"  style="width: 476px;min-height: 432px;">
                <div class="demo-title">投放示例</div>
                <div class="demo-imgs">
                  <div class="arrow-left" @click="prev(i._id)">
                    <i class="arrow-left-icon"></i>
                  </div>
                  <div class="arrow-right" @click="next(i._id)">
                    <i class="arrow-right-icon"></i>
                  </div>
                  <div class="demo-count"> <span>{{currentIndex}}</span>/{{   [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item).length }}</div>
                  <Carousel :ref="'carouselRef'+i._id" class='demo-content' :autoplay="true" :dots="false"  :after-change="changeIndex">
                    <div  v-for="(item, index) in  [i.pic1, i.pic2, i.pic3, i.pic4, i.pic5].filter(item => !!item)" :key="index" class="demo-imgWrapper">
                     <img :src="item" alt="carousel-img" style="width: 304px; height: 255px ;border-radius: 12px;" v-if="item">
                    </div>
                  </Carousel>
                </div>
                  <div class="demo-desc">{{ i.instruction }}</div>
                  <div  v-if="i.price"><span class="demo-price">刊例价：</span>{{i.price
                  }}元/档</div>
                  <div v-if="i.pricedesc"><span class="demo-price">价格说明：</span>{{ i.pricedesc }}</div>
              </div>
            </template>
            <a-button type="primary" @click="()=>jumpOutLink(i.link)" >{{ i.btn || '投放' }}</a-button>
          </a-popover>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import {http} from '@/utils/http'
  import jsCookie from 'js-cookie'
  import {  Carousel,Tabs,Popover } from 'ant-design-vue'
  const { TabPane } = Tabs
  export default {
    name: "home-pop",
    components: {
      Carousel,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Popover.name]: Popover,
      // [Carousel.name]:Carousel,
    },
    // mixins: [mixins],
    data() {
      return {
        mediaPromotion:[],
        marketing:[],
        fenzhong:[],
        activityApply:[],
        brand: [],
        interactive:[],
        kidsLeague:[],
        memberManager:[],
        privateTools:[],
        homeComponents: [],
        storePoint:[],
        fenzhongUnite:[],
        visible: true,
        tripartiteVisible: false,
        honourVisible: false,
        currentIndex: 1
      }
    },
    async created() {
    
      await this.getBusinessInfo()
      await this.adConfig()
      let cmsAd = '//cms.cekid.com/publish/976/platform_ad.json'
      const buzzType = jsCookie.get('buzzType')
      if(+buzzType == 4) {
        // 自营
        cmsAd = '//cms.cekid.com/publish/976/platform_ad_self.json'
      }
      if(+buzzType == 3) {
        // 品牌
         cmsAd = '//cms.cekid.com/publish/976/platform_ad_brand.json'
      }
      const res = await http.get(cmsAd)
      this.mediaPromotion = res.mediaPromotion;
      this.marketing = res.marketing;
      this.activityApply = res.activityApply;
      this.brand = res.brand;
      this.community = res.community;
      this.interactive = res.interactive;
      this.kidsLeague = res.kidsLeague;
      this.marketing = res.marketing;
      this.fenzhong = res.fenzhong;
      this.memberManager = res.memberManager;
      this.privateTools = res.privateTools;
      this.fenzhongUnite = res.fenzhongUnite;
      this.storePoint = res.storePoint;
    },
    computed: {
      ...mapState(['cmsConfig', 'isUggSell', 'businessInfo', 'homeAnnouncementList']),
      showConfirmModal() {
        // return true
        return this.visible && this.$store.state.showConfirmModal
      }
    },
    methods: {
      ...mapActions(['getBusinessInfo', 'getCMSAdConfig']),
      ...mapActions('cmsConfig', ['adConfig']),
    
      ...mapActions('popHome',[
        'setHonourFlag'
      ]),
      setMainContent(component) {
        this.$emit('setMainContent', component)
      },
      itemClick (link) {
        this.$emit('itemClick', link)
      },
      menuChange(item) {
        this.$emit('menuChange', item)
      },
      jumpLink(item) {
        this.$openLink(item)
      },
      jumpOutLink(item) {
        window.open(item)
      },
  
      toAccount() {
        const PROTOCOL = process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'
        const RECHARGE_URL = `${PROTOCOL}://open.haiziwang.com/platform/?link=${PROTOCOL}://ad.haiziwang.com/dashboard&hide=true`
        window.open(RECHARGE_URL)
      },
      gotoLink(url) {
        this.$emit('innerReffer', url, '', '', {})
      },
      gotoMore() {
        const PROTOCOL = 'https'
        const RECHARGE_URL = `${PROTOCOL}://b.haiziwang.com/store-point/business/home`
        window.open(RECHARGE_URL)
      },
      gotoPlan() {
          // todo
        const PROTOCOL = 'https'
        const RECHARGE_URL = `${PROTOCOL}://b.haiziwang.com/store-point/business/list`
        window.open(RECHARGE_URL)
      },
      /**
       *
       * @param link 跳转链接
       * @param openKeys<Array> 展开菜单集合
       * @param selectedKeys<Array> 选中集合
       */
       innerReffer (link, openKeys, selectedKeys, randomParam = true) {
        // 内部组件
        const innerComponents = [ 'promotion' ]
        const isInnerComponent = innerComponents.some(v => link === v)
        const url = isInnerComponent ? '' : link
        console.log('url====>', url)
        if (randomParam) {
          if (url && url.includes('?')) {
            this.url = `${url}&t=${new Date().getTime()}`
          } else {
            this.url = `${url}?t=${new Date().getTime()}`
          }
        } else {
          this.url = url
        }
        // 非外链记录点击记录
        this.currentComponent = 'promotion'
       
      },
      async prev(id) {
        this.$refs['carouselRef'+id][0] && this.$refs['carouselRef'+id][0].prev() 
      },
    
      next(id) {
        // await nextTick()
        this.$refs['carouselRef'+id][0] && this.$refs['carouselRef'+id][0].next() 
      },
      changeIndex(index) {
        this.currentIndex = index+1
      },
      resetCurrentIndex() {
        this.currentIndex = 1
      }
    }  
  }
</script>

<style lang="scss" scoped>
.home-container {
  z-index: 101;
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: 16px;
  max-width: 95%;
}
.sub-title {
  display: flex;
  justify-content: space-between;
  .sub-title-right {
    display: flex;
    
    align-content: center;
  }
 
  .account-btn {
    background: #ffffff;
    display: inline-block;
    margin-top: -6px;
    border: 1px solid #D0D5DD;
    width: 102px;
    height:32px;
    line-height: 32px;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    i {
      display: inline-block;
      width: 18px;
      height: 18px;
      background-size: 18px 16px;
      background-image: url('https://hzwimspic-1251601690.image.myqcloud.com/1/62e07d70-9836-11ef-a55a-21955df3a01a_size_18x16');
    }
  }
  ul {
    display: flex;
    color: #4E586C;
    margin-right: 24px;
    li {
      // padding: 0 11px;
      font-size: 16px;
      // border-right: 1px solid #8E95A5;
      a {
        font-size: 14px;
        color: #4E586C;
        &:hover {
          color: #409eff;
        }
      }
    }
    li::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #8E95A5;
      margin: 0 11px;
    }
    li:last-child::after {
    display: none;
  }
  }

}
.ad-item {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 15px;
  margin-right: 12px;
  // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  .ad-item-header {
    // h3 {
    // }
    display: flex;
    justify-content: space-between;

  }
  .ad-name {
    margin-top: 14px
  }
  .ad-tag {
    height: 20px;
    position: absolute;
    box-sizing: border-box;

    right: 0;
    top: 12px;
    line-height: 20px;
    background: #FF5B63;
    border-radius: 8px 14px 14px 2px;
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    padding: 0 6px;
  }

  .ad-item-content {
    padding: 20px;
    .ad-item-content-title {
      font-size: 18px;
      font-weight: 600;
      color: #121212;
      margin-bottom: 8px;
    }
    .ad-item-content-desc {
      font-size: 14px;
      color: #4E586C;
      margin-bottom: 8px;
    }
    .ad-item-content-btn {
      
    }
  }
}
.ad-item:hover {
  background: #F7F8FA;
}
h2 {
  font-size: 22px;
  color: #121212;
  font-weight: 600;
  margin-bottom: 16px;
}
.ad-item-header {
  width: 100%;
  height: 50px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  align-content: center;
  align-items: center;
  h3 {
    padding: 20px;
    font-size: 18px;
  }
  .account-btn-group {
    width: 240px;
    display: flex;
    justify-content: space-between;
  }
  .account-btn {
    background: #ffffff;
    margin-top: -6px;
    border: 1px solid #D0D5DD;
    min-width: 102px;
    padding: 7px 18px;
    color: #121212;
    height:32px;
    line-height: 32px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 6px;
    display: flex;
    align-items: center;
    cursor: pointer;
    i {
      display: inline-block;
      width: 18px;
      height: 16px;
      margin-right: 8px;
      background-size: 18px 16px;
      background-image: url('https://hzwimspic-1251601690.image.myqcloud.com/1/62e07d70-9836-11ef-a55a-21955df3a01a_size_18x16');
    }
  }
}
.ad-item-wrapper {

  background: #FFFFFF;
  border-radius: 12px;
  margin-bottom: 32px;
  // padding: 20px;
}
.ad-item-content {
  padding: 20px;
  display:flex;
  flex-wrap: wrap;
  .ad-item{
    width: 176px;
    height: 248px;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 80px;
    height: 80px;
    // background: #2668FF;
    border-radius: 8px;
  }
  .ad-item-more {
   img {
    width: 158px !important;
    height: 279px !important;
    border-radius: none
   }
  }
  .ad-name {
    font-weight: 600;
    font-size: 16px;
    color: #121212;
  }
  .ad-desc{
    font-size: 14px;
    color: #4E586C;
    line-height: 20px;
    margin-top: 8px;
    height: 60px;
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 60px; /* 设置为行高的两倍 */
  }
  .ad-btn{
    // background: #F1F3
    border: 1px solid #ACC5FF;
    border-radius: 20px;
    padding: 5px 20px;
    height: 32px;
    font-size: 14px;
    background: #fff;
    color: #2668FF;
    margin-top: 2px;
    cursor: pointer;
  }

}

.ad-point-content {
    padding: 20px;
    display:flex;
    flex-wrap: wrap;
    .ad-item-header {
    // h3 {
    // }

    display: flex;
    justify-content: space-between;

  }
    .ad-item{
    width: 176px;
    height: 315px;
    padding: 16px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 13px;
  
  }
  .ad-item-more {
    padding: 16px 16px;
    // margin-left: 10px;
    img {
      width: 158px !important;
      height: 279px !important;
    }
  }
 
    img {
      width: 146px;
      height: 146px;
      // background: #2668FF;
      border-radius: 8px;
    }
    .ad-item-content-title {
      font-size: 18px;
      font-weight: 600;
      color: #121212;
      margin-bottom: 8px;
    }
    .ad-item-content-desc {
      font-size: 14px;
      color: #4E586C;
      margin-bottom: 8px;
    }
    .ad-item-content-btn {
      
    }
    .ad-name {
    font-weight: 600;
    font-size: 16px;
    margin-top: 14px;
    color: #121212;
  }
  .ad-desc{
    font-size: 14px;
    color: #4E586C;
    line-height: 20px;
    margin-top: 8px;
    // margin-bottom: 9px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ad-btn{
    // background: #F1F3F7;
    border: 1px solid #ACC5FF;
    border-radius: 20px;
    padding: 5px 20px;
    height: 32px;
    font-size: 14px;
    color: #2668FF;
    margin-top: 12px;
    cursor: pointer;
  }
  }
.ad-row {
  margin: 20px;

  .home-col {
    padding: 8px;
  }
}
.content {

}

.ant-carousel >>> .slick-slide {
        text-align: center;
        height: 250px;
        line-height: 250px;
        background: #364d79;
        overflow: hidden;
      }

      .ant-carousel >>> .slick-slide h3 {
        color: #fff;
      }
      .ad-demo {
        z-index: 99999;
        // margin-top: 20px;
        position: relative;
        // width: 476px;
        // height: 502px;
        background: rgba(255,255,255,0.95);
        // box-shadow: 0px 8px 20px 0px #D4DAE6;
        // border: 1px solid #E5E6E8;
        padding: 24px;
      .demo-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #121212;
        line-height: 22px;
        margin-bottom: 10px;
        text-align: left;
        font-style: normal;
      }
    .demo-imgs {
      height: 255px;
      width: 304px;
      margin: 0 auto;
      margin-bottom: 22px;
      position: relative;
      .arrow-left {
        position: absolute;
        top: 50%;
        left: -68px;
        display: inline-block;
        width: 44px;
        height: 44px;
        background-color: #F7F8FA;
        // padding: 14px;
        border-radius: 50%;
        padding: 2px;
       .arrow-left-icon {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-left: 10px;
        margin-top:12px;
        background-size: 16px 16px;
        background-image: url('../../../assets/images/icon_arrow-left.png');
        background-repeat: no-repeat;
       }
      }
      .arrow-right{
        position: absolute;
        top: 50%;
        display: inline-block;
        width: 44px;
        height: 44px;
        right: -70px;
        background-color:  #F7F8FA;
        border-radius: 50%;
        padding: 14px;
        .arrow-right-icon{
          display: inline-block;
          width: 16px;
          height: 16px;
          background-size: 16px 16px;
          background-image: url('../../../assets/images/icon_arrow_right.png');
          background-repeat: no-repeat;
        }
      }
      .demo-count {
        position: absolute;
        right: -70px;
        bottom: -10px;
        width: 44px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        box-sizing: border-box;
        background: #EDEDED;
        border-radius: 13px;
        color: #4E586C;
        font-size: 14px;
        span {
          color: #2668FF;
        }
        
      }
      .demo-imgWrapper {
        background-color: #fff;
      }
      .demo-content{
      flex: 1;

      /deep/ .slick-slider{
        height: 50px;
        line-height: 50px;
        border-radius: 12px;
      }
    
  }
    }
    .demo-desc {
      font-weight: 400;
      font-size: 14px;
      color: #4E586C;
      line-height: 22px;
      margin-top: 10px;
    }
    .demo-price-tip {
      font-weight: 600;
      font-size: 14px;
      margin-top: 10px;
      display: inline-block;
      color: #121212;
      line-height: 22px;
    }
    .demo-price {
      color:  #2668FF;
      font-weight: 400;
    }
  
  }
//   .ad-demo:after {
//     content: "";
//       position: absolute;
//       left: 50%;
//       top: -20px;
//       width:0px;
//       height:0px;
//       border:10px solid #E5E6E8;
//       border-bottom-color: #fff ;
// }
.ad-item-wrapper {

  .ant-tabs-nav-wrap {
   
  }
}
</style>

<style lang="scss">
.ant-popover-inner {
  border-radius: 20px;
  box-shadow: 0px 8px 20px 0px #D4DAE6;
}
.ad-item-wrapper {
.ant-tabs-nav-wrap {
  font-size: 18px;
  height: 83px;
  background: linear-gradient( 180deg, #FFFFFF 0%, #F0F4FD 100%) !important;
  border: none;
  border-radius: 16px 16px 0 0;
  .ant-tabs-nav {
    margin-left: 24px;
    .ant-tabs-tab-active {
      color: #2668FF !important;
      font-weight: 600;
      font-size: 18px;
    }
    .ant-tabs-tab:hover {
      color: #2668FF;
      font-weight: 600;
      font-size: 18px;
    }
    .ant-tabs-ink-bar {
      height: 4px;
      bottom: 0px;
      border-radius: 3px;
      background-color:#2668FF
    }
  }
}
}
.menus .ant-menu-item-selected::after {
  border: none  !important;
}
.ant-menu-item-selected > a {
 
  color: #2163FF;
}
.ant-menu-item > a:hover{
  color: #2163FF;
}
.menu-item-leaf {
  .ant-menu-item-selected {
  background-color: #DFE7FD  !important;
}
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #DFE7FD  !important;
}


</style>
